import { render, staticRenderFns } from "./MultilobbyContainer.vue?vue&type=template&id=d435a996"
import script from "./MultilobbyContainer.vue?vue&type=script&lang=js"
export * from "./MultilobbyContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports